import type { I18nOptions } from "vue-i18n";
import { createI18n, I18n } from "vue-i18n";
import { nextTick } from "vue";

import messages from "@intlify/unplugin-vue-i18n/messages";

export const i18n = createI18n({
  locale: "en", // set locale
  allowComposition: true,
  fallbackLocale: "en",
  messages: messages as I18nOptions["messages"], // set locale messages
  warnHtmlInMessage: "off",
});

export const i18nGlobal = i18n.global;

export async function loadLanguageAsync(
  i18nLocal: I18n,
  lang: string,
  overrides?: any
) {
  // If the language hasn't been loaded yet
  i18nLocal.global.locale = lang;

  if (overrides) {
    setCustomLocalizations(lang, overrides);
  }

  // Vite plugin handles loading language files

  return nextTick();
}

function setCustomLocalizations(lang: string, overrides: any) {
  const messages = i18nGlobal.getLocaleMessage(lang);

  if (overrides) {
    for (const key in overrides) {
      if (overrides[key] && typeof overrides[key] === "string") {
        const path = key.split(".");
        let current = messages;
        for (let i = 0; i < path.length - 1; i++) {
          //@ts-expect-error
          if (!current[path[i]]) {
            //@ts-expect-error
            current[path[i]] = {};
          }
          //@ts-expect-error
          current = current[path[i]];
        }
        //@ts-expect-error
        current[path[path.length - 1]] = overrides[key];
      }
    }
  }
  i18nGlobal.setLocaleMessage(lang, messages);
}
